import { mergeSx } from "@/utils/styleHelpers";
import type { ReactElement } from "react";

import { Box } from "@/components/Box";
import type { BoxWithRCAndDomProps, MakeValidSxValue } from "@/types";

import { shimmerSx } from "./style";

export function ShimmerCircle<RC extends ReactElement | undefined = undefined>({
  sx,
  radius = "50px",
  className,
  ...props
}: BoxWithRCAndDomProps<RC> & { radius?: MakeValidSxValue<string> }) {
  return (
    <Box
      {...props}
      sx={mergeSx(shimmerSx, { brad: "50%", w: radius, h: radius }, sx)}
      className={`${className ?? ""} ShimmerCircle`}
    />
  );
}

ShimmerCircle.displayName = "ShimmerCircle";
